<template lang="html">
  <CaseSummaryContainer>
    <Header slot="header" :heading="'Recommendations'" :methodology="methodology" @print="print"><span class="heading subtitle" slot="subtitle">Made to the California Department of Corrections and Rehabilitation</span></Header>
    <RecommendationFilter slot="caseBlockFilter" v-show="filterValues" :recommendations="filteredRecommendations" @applyFilter="applyFilter"/>
    <PrintArea slot="printArea" :filteredRecommendations="filteredRecommendations" :reportFilter="filter" />
    <RecommendationBlock slot="caseBlock" v-for="recommendation in filteredRecommendations" v-bind:key="recommendation.id" :recommendation="recommendation" />
    <b-jumbotron fluid class="text-center" slot="caseBlock" v-show="typeof filteredRecommendations != 'undefined' && !filteredRecommendations.length">There are no recommendations which match your selected filters.</b-jumbotron>
  </CaseSummaryContainer>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-142178256-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-142178256-1');
</script>
<script>
import CaseSummaryContainer from '@/components/CaseSummaryContainer.vue'
import Header from '@/components/Header.vue'
import RecommendationFilter from '@/components/Recommendations/components/RecommendationFilter.vue'
export default {
  components: {
    Header,
    RecommendationBlock: () => import( /* webpackChunkName: 'rxRecommendationBlock' */ '@/components/Recommendations/components/RecommendationBlock.vue'),
    RecommendationFilter,
    CaseSummaryContainer,
    PrintArea: () => import( /* webpackChunkName: 'rxPrintArea' */ '@/components/Recommendations/components/PrintArea.vue')
  },
  data() {
    return {
      filter: {},
      methodology: '<div class="container-fluid" id="methodology"><div class="row"><div class="col"><p>The Office of Inspector General oversees and reports on several aspects of the California Department of Corrections and Rehabilitation (the department), such as employee discipline monitoring, use-of-force monitoring, audits, and authorized special reviews. Many of our reports contain recommendations to the department to improve its policies, procedures, or practices. Following publication, we request the department to provide its status on implementing our recommendation at 60 days, six months, one year, and annually thereafter. The implementation status of a recommendation is defined as follows:</p><p><span class="fullyImplemented">Fully Implemented: </span>The department implemented the recommendation in its entirety.</p><p><span class="partiallyImplemented">Partially Implemented: </span>The department implemented a material portion of the recommendation, or is in the process of implementing at least a material portion of the recommendation.</p><p><span class="notImplemented">Not Implemented: </span>The department has not taken steps to implement the recommendation. Recommendations that are of "pending" status after one year without any material changes or updates will automatically be moved into this category.</p><p><span class="pending">Pending: </span>The department has not provided a status on its implementation or is in the process of determining whether it will implement our recommendation.</p></div></div></div>'
    }
  },

  methods: {
    applyFilter: function(filter) {
      this.filter = filter
    },
    print: function() {
      window.print()
    },
    convertToChosen(elements) {
      return elements.map(e => {
        return {
          value: e,
          text: e
        }
      })
    }
  },
  computed: {
    recommendations() {
      return this.$store.getters['oigRecommendations/recommendations']
    },
    filterValues() {
      return this.$store.getters['oigRecommendations/filterValues']
    },
    filteredRecommendations() {
      if (typeof this.recommendations === 'undefined') return []
      if (Object.keys(this.filter).length === 0) return this.recommendations
      return this.recommendations.filter(r => {
        return Object.keys(this.filter).every(f => {
          if (this.filter[f] === null || this.filter[f].length === 0) return true
          switch (f) {
            case 'publishYears':
              return this.filter[f].indexOf(new Date(r.publishedDate).getFullYear().toString()) >= 0
            case 'startDate':
              return Date.parse(r.publishedDate) >= this.filter[f]
            case 'endDate':
              return Date.parse(r.publishedDate) <= this.filter[f]
            default:
              return this.filter[f].indexOf(r[f]) >= 0
          }
        })
      })
    }
  }
}
</script>

<style lang="css">

</style>
